/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DocumentDelete = {
  status: string;
};

/** @internal */
export const DocumentDelete$inboundSchema: z.ZodType<
  DocumentDelete,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: z.string(),
});
/** @internal */
export type DocumentDelete$Outbound = {
  status: string;
};

/** @internal */
export const DocumentDelete$outboundSchema: z.ZodType<
  DocumentDelete$Outbound,
  z.ZodTypeDef,
  DocumentDelete
> = z.object({
  status: z.string(),
});

export function documentDeleteToJSON(documentDelete: DocumentDelete): string {
  return JSON.stringify(DocumentDelete$outboundSchema.parse(documentDelete));
}
export function documentDeleteFromJSON(
  jsonString: string,
): SafeParseResult<DocumentDelete, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentDelete$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentDelete' from JSON`,
  );
}
